module.exports = __webpack_public_path__ + "static/media/clipboard-list.826b5687.svg";